<template>
    <DCard
        padding
    >
        <Form
            :cloudpit-settings="cloudpitSettings"
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/CloudpitSettings/Form'

export default {
    name: 'CloudpitSettingsCreate',
    components: {
        Form
    },
    props: {
        cloudpitSettings: {
            type: Object,
            default () {
                return {}
            }
        },
        errors: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('settings.cloudpit-settings.store'))
        }
    }
}
</script>
